import { Box, BoxProps, Text } from 'grommet';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { TalonCard } from '..';
import { useProjectStore, useTalentManagerStore } from '../../../context';

export type TalentManagerPanelProps = {
  cardProps?: BoxProps;
  headerBackground?: string;
};

export const TalentManagerPanel = observer(({ cardProps, headerBackground }: TalentManagerPanelProps) => {
  const tmStore = useTalentManagerStore();
  const projectStore = useProjectStore();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    tmStore.fetchGroupEngagements().then(() => setLoading(false));
  }, []);

  const engagements = tmStore.groupEngagements.filter((e) => e.project_id === projectStore.currentProject?.id);

  return (
    <TalonCard
      label="Talent Managers"
      cardProps={cardProps}
      headerBackground={headerBackground}
      hideFooter
      isLoading={loading}
    >
      {engagements.length === 0 ? (
        <Text size="small" color="dark-4" margin="small">
          No Talent Manager engaged yet.
        </Text>
      ) : (
        engagements.map((e) => (
          <Box key={e.id} pad="small" border={{ side: 'bottom', color: 'light-3' }}>
            <Text weight="bold" size="small">
              {e.talentManagerProfile?.user?.first_name} {e.talentManagerProfile?.user?.last_name}
            </Text>
            <Text size="xsmall" color="dark-4">
              Status: {e.status}
            </Text>
          </Box>
        ))
      )}
    </TalonCard>
  );
});
